import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/ErrorOutline";

interface ToastProps {
  info?: string;
  message: string;
  type?: "success" | "error" | "info";
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
  message,
  info,
  type = "success",
  onClose,
}) => {
  const theme = useTheme();
  const getBackgroundColor = () => {
    switch (type) {
      case "error":
        return theme.palette.custom.foreground.attention;
      case "success":
        return theme.palette.custom.foreground.progress;
      default:
        return theme.palette.custom.foreground.primary;
    }
  };

  const getIcon = () => {
    return type === "error" || type === "info" ? (
      <ErrorIcon sx={{ marginRight: 1 }} />
    ) : (
      <CheckCircleIcon sx={{ marginRight: 1 }} />
    );
  };

  return (
    <Box
      position="fixed"
      left={64}
      right={0}
      display="flex"
      p="20px"
      zIndex={10}
      justifyContent="space-between"
      sx={{
        backgroundColor: getBackgroundColor(),
        color: "white",
      }}
    >
      <Box display="flex">
        {getIcon()}
        <Box>
          <Typography sx={{ fontWeight: 700 }}>{message}</Typography>
          <Typography sx={{ fontSize: "13px" }}>{info}</Typography>
        </Box>
      </Box>
      <Box sx={{ cursor: "pointer" }} onClick={onClose}>
        ✖
      </Box>
    </Box>
  );
};

export default Toast;
